import { t } from "i18next";
import { Dispatch, RefObject, SetStateAction, SyntheticEvent, useMemo } from "react";
import { HjorteviltJaktdataV1JaktdagSharedJaktdagResponse } from "~/src/api/generated/api";
import { firstNonEmpty } from "~/src/helpers/filters";
import { useConfirmationDialog } from "~/src/hooks/useConfirmationDialog";
import useRegistrerJaktdag from "../common/useRegistrerJaktdag";
import {
  JaktdagRegistrationDataHjort,
  TermiskMap,
  settHjortInnmarkDataKeys,
  settHjortUtmarkDataKeys,
  skuttHjortInnmarkDataKeys,
  skuttHjortUtmarkDataKeys,
} from "./HjortTypes";

export default function useRegistrerHjort(
  initialData: HjorteviltJaktdataV1JaktdagSharedJaktdagResponse | undefined,
  scrollTopRef: RefObject<HTMLDivElement>,
) {
  const {
    jaktdagEksistererDialog,
    eksisterendeJaktdag,
    isSubmitting,
    successDialog,
    handleSubmit,
    handleChangeJaktomrade,
    formData: formData,
    formErrorsHjort: formErrors,
    setFormData,
    setFormErrorsHjort: setFormErrors,
    selectedJaktomrade,
    date,
    fellingsRapportLevert,
    loadingEksisterendeJaktdager,
    hasGodkjenteDyr,
  } = useRegistrerJaktdag(initialData, scrollTopRef, "Hjort");

  const terrengHarRegistreringerDialog = useConfirmationDialog({
    confirmButtonText: t("pages.registrering.dialogs.terrengHarRegistreringer.confirmButtonText"),
  });

  const counterErrorMessages = useMemo(() => {
    const settInnmark =
      firstNonEmpty(settHjortInnmarkDataKeys.map((field) => formErrors[field])) ||
      formErrors["AntallJegereInnmark"] ||
      formErrors["AntallTimerJaktetInnmark"];
    const settUtmark =
      firstNonEmpty(settHjortUtmarkDataKeys.map((field) => formErrors[field])) ||
      formErrors["AntallJegere"] ||
      formErrors["AntallTimerJaktet"];
    const skuttInnmark = firstNonEmpty(skuttHjortInnmarkDataKeys.map((field) => formErrors[field]));
    const skuttUtmark = firstNonEmpty(skuttHjortUtmarkDataKeys.map((field) => formErrors[field]));

    return { settInnmark, settUtmark, skuttInnmark, skuttUtmark };
  }, [formErrors]);

  return {
    jaktdagEksistererDialog,
    eksisterendeJaktdag,
    isSubmitting,
    successDialog,
    counterErrorMessages,
    handleSubmit: (event: SyntheticEvent, termiskMap?: TermiskMap) =>
      handleSubmit(event, termiskMap),
    handleChangeJaktomrade,
    formData: formData as JaktdagRegistrationDataHjort,
    formErrors,
    setFormData: setFormData as Dispatch<SetStateAction<JaktdagRegistrationDataHjort>>,
    setFormErrors,
    selectedJaktomrade,
    date,
    fellingsRapportLevert,
    terrengHarRegistreringerDialog,
    loadingEksisterendeJaktdager,
    hasGodkjenteDyr,
  };
}
